var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1166",
    "data-name": "Groupe 1166",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.996,
    height: 17.46,
    viewBox: "0 0 18.996 17.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_491",
    "data-name": "Trac\\xE9 491",
    d: "M164.123,62.776l3.636-3.267V54.882h2.093v2.81l3.73-3.36,9.538,8.444v9.015h-6.91v-2.81a2.711,2.711,0,0,0-2.629-2.723h0a2.7,2.7,0,0,0-2.55,2.723v2.81h-6.909Zm5.178,5.481h-1.811v1.9H169.3Zm-2.18-2.274H165.3v2h1.818Zm2.18,0h-1.811v2H169.3Zm-2.18,2.274H165.3v1.9h1.818Z",
    transform: "translate(-164.123 -54.332)",
    fill: "#a9aaad",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.bec44d13484dff82db5ebda36cca7f28.svg";
export { ForwardRef as ReactComponent };